import axios from '../util/axiosConfig';


export const createSessionIdAPI = async (pacsId) => {
    let params = {
        pacsId: pacsId
    }
    return await axios.get('api/integrator/createSessionID', { params })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false }
            }
        }).catch(function (error) {
            return { success: false }
        })
}


export const fetchPriorAccessionNo = async (patientId) => {
    let params = {
        patientId: patientId
    }
    return await axios.get('/api/v1/prior-pacs-study', { params })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false }
            }
        }).catch(function (error) {
            return { success: false }
        })
}